import React, { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"],
  ],
};

export default function RichTextEditor({ value, onChange, readOnly = false, placeholder = "" }) {
  const modules = useMemo(() => DEFAULT_MODULES, []);

  return (
    <div className={`cms-rich-text-editor${readOnly ? " cms-rich-text-editor--readonly" : ""}`}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        readOnly={readOnly}
        placeholder={placeholder}
      />
    </div>
  );
}
